import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Tabs,
  Select,
  Image,
  Popover,
} from 'antd';
import IntlMessages from '../../components/IntlMessage';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useIntl } from 'react-intl';
import destinationsApi from '../../api/destinations';

import UploadImage from '../../components/Elements/UploadImage';
import countriesApi from '../../api/countries';
import { TreeSelect } from 'antd';
// import CustomPlacesAutoComplete from '../../components/Elements/CustomPlacesAutoComplete';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { debounce } from 'lodash';
const { Option } = Select;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

export default function DestinationsForm(props) {
  const isMount = useRef(false);
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState([]);
  const [destTree, setDestTree] = useState([]);
  const [ImageUrl, setImageUrl] = useState({
    disable: false,
    url: currentData && currentData.cover_image ? currentData.cover_image : '',
  });
  //console.log("?",loading)
  const intl = useIntl();
  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        };
        let countries = await countriesApi.getAll(filter);
        let destTrees = await destinationsApi.getTree();
        setCountry(countries.data);
        setDestTree(destTrees);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);
  // duyet mang theo form treeData
  const map = (e) => ({
      title: e.title,
      value: e.id,
      children: e.children.map(map), // recursive call
    }),
    treeData = destTree.map(map);

  // console.log('treeData', treeData);
  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        //data.propertytypes = JSON.stringify(data.propertytypes);
        data.featured = data.featured ? 1 : 0;
        delete data.cover_image;
        delete data.url;
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        if (imgs) {
          formData.append('cover_image', imgs);
          formData.delete('url');
        } else if (values?.url && values?.url !== currentData?.cover_image) {
          formData.append('cover_image', values.url);
        }

        if (currentData) {
          if (form.getFieldValue('parent_id') === null) {
            formData.delete('parent_id');
          }

          if (form.getFieldValue('parent_id') === undefined) {
            formData.append('parent_id', null);
          }
          destinationsApi
            .update(currentData.id, formData)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch(() => setLoading(false));
        } else {
          if (form.getFieldValue('parent_id') === null)
            formData.delete('parent_id');
          destinationsApi
            .create(formData)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch(() => setLoading(false));
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const onSetLocation = (position, address, city_name) => {
    //var form = this.props.formRef.current;
    var data = {
      latitude: +position.lat,
      longitude: +position.lng,
    };
    form.setFieldsValue({ latitude: position.lat, longitude: position.lng });
  };
  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  const onChangeUrl = debounce((e) => {
    setImageUrl({
      disable: false,
      url: e.target.value,
    });
  }, 1000);

  let initialValue = {
    title: currentData && currentData.title ? currentData.title : '',
    description:
      currentData && currentData.description ? currentData.description : '',
    cover_image:
      currentData && currentData.cover_image ? currentData.cover_image : '',
    url: currentData && currentData.cover_image ? currentData.cover_image : '',
    country_id:
      currentData && currentData.country && currentData.country.id
        ? currentData.country.id
        : null,
    parent_id:
      currentData && currentData.parentId ? currentData.parentId : null,
    longitude:
      currentData && currentData.longitude ? currentData.longitude : '',
    latitude: currentData && currentData.latitude ? currentData.latitude : '',
    status: currentData && currentData.status ? 1 : 0,
    featured: !!(currentData && currentData.featured),
  };

  // console.log('initialValue', currentData);

  const fileList = useMemo(
    () =>
      currentData && currentData.cover_image
        ? [
            {
              uid: '1',
              name: 'image.png',
              status: 'done ',
              url: currentData.cover_image,
            },
          ]
        : [],
    [currentData],
  );

  const [imgs, setImgs] = useState(null);

  const onChangeImage = (v, f) => {
    setImgs(f);
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.destination" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Ville" />
          </Form.Item>

          <Form.Item
            name="country_id"
            label={<IntlMessages id="global.countries" />}
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Select
              showSearch
              placeholder="Pays"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {country.map((option, index) => {
                return (
                  <Option key={`${option.id}_${index}`} value={option.id}>
                    {option.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            name="parent_id"
            label={<IntlMessages id="global.destination_parent" />}
            rules={[
              {
                required: false,
              },
            ]}>
            <TreeSelect
              style={{
                width: '100%',
              }}
              dropdownStyle={{
                maxHeight: 400,
                overflow: 'auto',
              }}
              treeData={treeData}
              placeholder="Ville parent"
              allowClear
              treeDefaultExpandAll
            />
          </Form.Item>
          <Form.Item
            name="featured"
            label={<IntlMessages id="tour.featured" />}
            valuePropName="checked">
            <Checkbox defaultChecked={initialValue.featured ? true : false}>
              Special
            </Checkbox>
          </Form.Item>
          <Form.Item name="status" label={<IntlMessages id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessages id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessages id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.cover_image" />}
            name="cover_image">
            <UploadImage onChangeData={onChangeImage} initList={fileList} />
          </Form.Item>
          <Form.Item label={<IntlMessages id="global.url" />}>
            <Form.Item name="url">
              <Input onChange={onChangeUrl} />
            </Form.Item>
            <Form.Item>
              <Popover
                content={
                  !ImageUrl.disable && (
                    <Image style={{ maxWidth: '300px' }} src={ImageUrl.url} />
                  )
                }>
                <Button>Afficher</Button>
              </Popover>
            </Form.Item>
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="global.description" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.description" />}
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
            valuePropName="data"
            getValueFromEvent={(event, editor) => {
              const data = editor.getData();
              // console.log({ event, editor, data });
              return data;
            }}>
            <CKEditor editor={ClassicEditor} />
          </Form.Item>
          {/* <DebounceSelect
        mode="multiple"
        value={value}
        placeholder="Select users"
        fetchOptions={fetchUserList}
        onChange={(newValue) => {
          setValue(newValue);
        }}
        style={{
          width: "100%",
        }}
      /> */}
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValue}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems}>
          {/* <TabPane tab={<IntlMessages id="global.location" />} key="3">
            <Form.Item label={<IntlMessages id="global.location" />}>
              <CustomPlacesAutoComplete
                onChange={onSetLocation}
                defaultadressMap={''}
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="destination.latitude" />}
              name="latitude"
              rules={[
                {
                  required: false,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="destination.longitude" />}
              name="longitude"
              rules={[
                {
                  required: false,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </TabPane> */}
        </Tabs>
      </Form>
    </Modal>
  );
}
